import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'dream_soundtrack'

export default function DreamSoundtrackPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'If your dreams had a soundtrack…',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.dreamSoundtrack.heading')}
      buttons={[
        {
          text: `🎻 ${t('pages.onboarding.dreamSoundtrack.options.emotionalCinematic')}`,
          value: 'Emotional & cinematic',
        },
        {
          text: `🔊 ${t('pages.onboarding.dreamSoundtrack.options.chaoticBeats')}`,
          value: 'Chaotic beats',
        },
        {
          text: `🫠 ${t('pages.onboarding.dreamSoundtrack.options.echoesWhispers')}`,
          value: 'Echoes & whispers',
        },
        {
          text: `🪕 ${t('pages.onboarding.dreamSoundtrack.options.dreamyFolk')}`,
          value: 'Dreamy folk',
        },
        {
          text: `🫥 ${t('pages.onboarding.dreamSoundtrack.options.silence')}`,
          value: ' Silence',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
